// BillingSummary.ts
import BilledStore from "./BilledStore";

export default class BillingSummary {
  billedStores: Map<string, BilledStore[]>;

  total: number;

  constructor(billedStores: Map<string, BilledStore[]>, total: number) {
    this.billedStores = billedStores;
    this.total = total;
  }

  static fromJson(x: any) {
    var result = new Map<string, BilledStore[]>();

    for (const [key, value] of Object.entries(x.billedStores)) {
      console.log(value);
      const stores = (<any>value).map((store: any) =>
        BilledStore.fromJson(store)
      );
      result.set(key, stores);
    }
    return new BillingSummary(result, x.total);
  }
}
